import {setConfig} from 'react-hot-loader';
import './src/styles/global.scss';

export const onClientEntry = () => {
  setConfig({
    pureSFC: true,
    pureRender: true
  });
};

// TODO use Initial Client render to determine if gatsby has been initialized and pass that state to a provider

